import React from 'react'
import "./Footer.css";

function Footer() {
  return (
    <div className="footer-content">
        © 2024 Muhammad Affan
    </div>
  )
}

export default Footer
